import { Button } from '@/components/ui/button';
import { ArrowRight, Zap } from 'lucide-react';

export const HeroSection = ({ onContactClick }) => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/bw4cwh9g_Hero.png"
          alt="Datacenter Infrastructure"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 gradient-hero" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 pt-20">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-primary/10 backdrop-blur-sm border border-primary/20 rounded-full px-4 py-2 mb-8 animate-fade-in">
            <Zap className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary">
              Innovative Energiespeicherlösungen
            </span>
          </div>

          {/* Headline */}
          <h1 className="font-heading font-bold text-3xl sm:text-5xl lg:text-7xl text-primary-foreground mb-6 leading-tight animate-fade-in">
            BESS & Rechenzentren:
            <br />
            <span className="text-primary-glow">Effizienz, Skalierbarkeit, Zukunft</span>
          </h1>

          {/* Description */}
          <p className="text-base sm:text-xl text-primary-foreground/90 mb-8 max-w-2xl leading-relaxed animate-fade-in">
            Battery Energy Storage Systems (BESS) revolutionieren die Art und
            Weise, wie Rechenzentren Energie speichern, verwalten und
            optimieren. Entdecken Sie, wie intelligente Speicherlösungen Ihre
            Infrastruktur zukunftssicher machen.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in">
            <Button
              size="lg"
              className="group text-base px-8 py-6 shadow-glow hover:shadow-lg transition-all"
              data-testid="hero-cta-primary"
            >
              Lösungen entdecken
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="text-base px-8 py-6 bg-background/10 backdrop-blur-sm border-primary-foreground/30 text-primary-foreground hover:bg-background/20 hover:border-primary-foreground/50"
              data-testid="hero-cta-secondary"
              onClick={onContactClick}
            >
              Kontakt aufnehmen
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 sm:gap-6 mt-10 sm:mt-16 max-w-2xl animate-fade-in">
            <div className="text-center sm:text-left">
              <div className="font-heading font-bold text-2xl sm:text-4xl text-primary-glow mb-1">
                99.9%
              </div>
              <div className="text-xs sm:text-sm text-primary-foreground/80">
                Verfügbarkeit
              </div>
            </div>
            <div className="text-center sm:text-left">
              <div className="font-heading font-bold text-2xl sm:text-4xl text-primary-glow mb-1">
                30%
              </div>
              <div className="text-xs sm:text-sm text-primary-foreground/80">
                Kostensenkung
              </div>
            </div>
            <div className="text-center sm:text-left">
              <div className="font-heading font-bold text-2xl sm:text-4xl text-primary-glow mb-1">
                24/7
              </div>
              <div className="text-xs sm:text-sm text-primary-foreground/80">
                Monitoring
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - hidden on mobile */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce hidden md:block">
        <div className="w-6 h-10 border-2 border-primary-foreground/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-primary-glow rounded-full" />
        </div>
      </div>
    </section>
  );
};